import { cn } from '@/utils/cn'
import { type ComponentPropsWithoutRef, type ElementRef, forwardRef } from 'react'

import * as LabelPrimitive from '@radix-ui/react-label'

export type LabelProps = ComponentPropsWithoutRef<typeof LabelPrimitive.Root>

export const Label = forwardRef<ElementRef<typeof LabelPrimitive.Root>, LabelProps>(({ className, ...props }, ref) => (
  <LabelPrimitive.Root
    ref={ref}
    className={cn(
      'inline-flex cursor-pointer items-center gap-2 leading-none transition-colors',
      'peer-disabled:cursor-not-allowed peer-disabled:text-disabled-foreground has-[:disabled]:cursor-not-allowed has-[:disabled]:text-disabled-foreground',
      'hocus-within:text-accent peer-focus-visible:text-accent',
      className
    )}
    {...props}
  />
))
Label.displayName = LabelPrimitive.Root.displayName
